/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceAlertTask
 */
export interface DeviceAlertTask {
    /**
     *
     * @type {string}
     * @memberof DeviceAlertTask
     */
    alertType?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceAlertTask
     */
    startTime?: Date;
    /**
     *
     * @type {number}
     * @memberof DeviceAlertTask
     */
    durationSeconds?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertTask
     */
    message?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertTask
     */
    derEventId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertTask
     */
    deviceType?: DeviceAlertTaskDeviceTypeEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertTask
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertTask
     */
    timeToLive?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceAlertTask
     */
    scheduledTime?: Date;
}

/**
 * @export
 */
export const DeviceAlertTaskDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceAlertTaskDeviceTypeEnum =
    (typeof DeviceAlertTaskDeviceTypeEnum)[keyof typeof DeviceAlertTaskDeviceTypeEnum];

/**
 * Check if a given object implements the DeviceAlertTask interface.
 */
export function instanceOfDeviceAlertTask(
    value: object,
): value is DeviceAlertTask {
    return true;
}

export function DeviceAlertTaskFromJSON(json: any): DeviceAlertTask {
    return DeviceAlertTaskFromJSONTyped(json, false);
}

export function DeviceAlertTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceAlertTask {
    if (json == null) {
        return json;
    }
    return {
        alertType: json["alertType"] == null ? undefined : json["alertType"],
        startTime:
            json["startTime"] == null ? undefined : new Date(json["startTime"]),
        durationSeconds:
            json["durationSeconds"] == null
                ? undefined
                : json["durationSeconds"],
        message: json["message"] == null ? undefined : json["message"],
        derEventId: json["derEventId"] == null ? undefined : json["derEventId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        timeToLive: json["timeToLive"] == null ? undefined : json["timeToLive"],
        scheduledTime:
            json["scheduledTime"] == null
                ? undefined
                : new Date(json["scheduledTime"]),
    };
}

export function DeviceAlertTaskToJSON(value?: DeviceAlertTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        alertType: value["alertType"],
        startTime:
            value["startTime"] == null
                ? undefined
                : value["startTime"].toISOString(),
        durationSeconds: value["durationSeconds"],
        message: value["message"],
        derEventId: value["derEventId"],
        deviceType: value["deviceType"],
        deviceId: value["deviceId"],
        timeToLive: value["timeToLive"],
        scheduledTime:
            value["scheduledTime"] == null
                ? undefined
                : value["scheduledTime"].toISOString(),
    };
}
